import { render, staticRenderFns } from "./guard_config_view.vue?vue&type=template&id=4a38317d&scoped=true"
import script from "./guard_config_view.vue?vue&type=script&lang=js"
export * from "./guard_config_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a38317d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a38317d')) {
      api.createRecord('4a38317d', component.options)
    } else {
      api.reload('4a38317d', component.options)
    }
    module.hot.accept("./guard_config_view.vue?vue&type=template&id=4a38317d&scoped=true", function () {
      api.rerender('4a38317d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/config/guard_config_view.vue"
export default component.exports